// GENERATED by scripts/stamp-build.js at build time (npm `prebuild`). Do not edit.
//
// The value committed to the repo is a PLACEHOLDER and says so in `source`. Every build
// overwrites this file, so a bundle whose source is `placeholder` was never stamped and a
// bundle whose source is `unresolved` was stamped where no commit could be determined.
export const buildInfo = {
  "sha": "1ffb9f3d3fb39de42dd4a21336dedc243264a617",
  "source": "cloudflare-pages",
  "builtAt": "2026-11-05T12:10:12.825Z"
};

export default buildInfo;
